import { render, staticRenderFns } from "./MonitorView.vue?vue&type=template&id=ecd0abfa&scoped=true"
import script from "./MonitorView.vue?vue&type=script&lang=js"
export * from "./MonitorView.vue?vue&type=script&lang=js"
import style0 from "./MonitorView.vue?vue&type=style&index=0&id=ecd0abfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd0abfa",
  null
  
)

export default component.exports